import { fork, all } from 'redux-saga/effects'
// eslint-disable-next-line import/no-named-as-default, temporary until we only export the one thing
import actionTypes from '../../actionTypes'
import actions from '../../actionCreators'
import { processSaga, chainSagas, watchSaga } from '../workflow'
import { authStateChangedWatch, onLogoutSuccess, onLoginSuccess, facebookLogin, instagramLogin, instagramRedirectLogin, instagramRedirectLoginComplete, emailLogin, emailLoginComplete, facebookRedirectLogin, facebookRedirectLoginComplete, createUserProfile, createVerifications, login, logout, cleanupData } from './sagas'

const facebookLoginWorkflow = processSaga.bind(null, actions.authFacebookPopup.login, facebookLogin)
const instagramLoginWorkflow = processSaga.bind(null, actions.authInstagramPopup.login, instagramLogin)
const emailLoginWorkflow = processSaga.bind(null, actions.authEmail.login, emailLogin)
const emailLoginCompleteWorkflow = processSaga.bind(null, actions.authEmail.loginComplete, emailLoginComplete)
const facebookRedirectLoginWorkflow = processSaga.bind(null, actions.authFacebookRedirect.login, facebookRedirectLogin)
const facebookRedirectLoginCompleteWorkflow = processSaga.bind(null, actions.authFacebookRedirect.loginComplete, facebookRedirectLoginComplete)
const instagramRedirectLoginWorkflow = processSaga.bind(null, actions.authInstagramRedirect.login, instagramRedirectLogin)
const instagramRedirectLoginCompleteWorkflow = processSaga.bind(null, actions.authInstagramRedirect.loginComplete, instagramRedirectLoginComplete)
const logoutWorkflow = processSaga.bind(null, actions.auth.logout, logout)
const loginWorkflow = processSaga.bind(null, actions.auth.login, login)

const loginWorkflowChain = chainSagas.bind(null, [createUserProfile, loginWorkflow, onLoginSuccess, createVerifications])
const emailLoginWorkflowChain = chainSagas.bind(null, [logoutWorkflow, emailLoginWorkflow])
const emailLoginCompleteWorkflowChain = chainSagas.bind(null, [emailLoginCompleteWorkflow, loginWorkflowChain]) // TODO: maybe try to just stay logged in if already logged in?
const facebookRedirectLoginWorkflowChain = chainSagas.bind(null, [logoutWorkflow, facebookRedirectLoginWorkflow])
const facebookRedirectLoginCompleteWorkflowChain = chainSagas.bind(null, [facebookRedirectLoginCompleteWorkflow, loginWorkflowChain])
const facebookPopupLoginWorkflowChain = chainSagas.bind(null, [logoutWorkflow, facebookLoginWorkflow, loginWorkflowChain])
const instagramPopupLoginWorkflowChain = chainSagas.bind(null, [logoutWorkflow, instagramLoginWorkflow, loginWorkflowChain])
const instagramRedirectLoginWorkflowChain = chainSagas.bind(null, [logoutWorkflow, instagramRedirectLoginWorkflow])
const instagramRedirectLoginCompleteWorkflowChain = chainSagas.bind(null, [instagramRedirectLoginCompleteWorkflow, loginWorkflowChain])
const logoutWorkflowChain = chainSagas.bind(null, [logoutWorkflow, cleanupData, onLogoutSuccess])

const logoutWatch = watchSaga.bind(null, actionTypes.auth.logout.TRIGGER, logoutWorkflowChain)
const facebookPopupLoginWatch = watchSaga.bind(null, actionTypes.authFacebookPopup.login.TRIGGER, facebookPopupLoginWorkflowChain)
const instagramPopupLoginWatch = watchSaga.bind(null, actionTypes.authInstagramPopup.login.TRIGGER, instagramPopupLoginWorkflowChain)
const emailLoginWatch = watchSaga.bind(null, actionTypes.authEmail.login.TRIGGER, emailLoginWorkflowChain)
const emailLoginCompleteWatch = watchSaga.bind(null, actionTypes.authEmail.loginComplete.TRIGGER, emailLoginCompleteWorkflowChain)
const facebookRedirectLoginWatch = watchSaga.bind(null, actionTypes.authFacebookRedirect.login.TRIGGER, facebookRedirectLoginWorkflowChain)
const facebookRedirectLoginCompleteWatch = watchSaga.bind(null, actionTypes.authFacebookRedirect.loginComplete.TRIGGER, facebookRedirectLoginCompleteWorkflowChain)
const instagramRedirectLoginWatch = watchSaga.bind(null, actionTypes.authInstagramRedirect.login.TRIGGER, instagramRedirectLoginWorkflowChain)
const instagramRedirectLoginCompleteWatch = watchSaga.bind(null, actionTypes.authInstagramRedirect.loginComplete.TRIGGER, instagramRedirectLoginCompleteWorkflowChain)
const authAlreadyVerifiedWatch = watchSaga.bind(null, actionTypes.authAlreadyVerified, createVerifications)

export default function* root() {
	yield all([
		fork(authStateChangedWatch),
		fork(authAlreadyVerifiedWatch),
		fork(logoutWatch),
		fork(facebookPopupLoginWatch),
		fork(instagramPopupLoginWatch),
		fork(emailLoginWatch),
		fork(emailLoginCompleteWatch),
		fork(facebookRedirectLoginWatch),
		fork(facebookRedirectLoginCompleteWatch),
		fork(instagramRedirectLoginWatch),
		fork(instagramRedirectLoginCompleteWatch)
	])
}



// WEBPACK FOOTER //
// ./src/redux/saga/auth/index.js